import { useTenantDetailsContext } from '../TenantDetailsContext';

export function useAICapabilitiesEnabled(): boolean {
  const { applicationConfiguration } = useTenantDetailsContext();
  // The configuration flag is for if AI is disabled, so we need to negate it
  // Also, if the configuration is not present, we should default to enabled
  return !applicationConfiguration?.disableAiCapabilities;
}
